import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Group } from '@src/types/Group';

const useUserGroups = (userId: string | undefined) =>
  useApiQuery<Group[]>({
    queryKey: [QueryKeys.userGroups, userId ?? ''],
    apiPath: `/users/${userId}/groups`,
    method: 'GET',
    useV2API: true,
    enabled: !!userId,
  });

export default useUserGroups;
